import PreviewNav from "./PreviewNav";

export default function PreviewHero({ config, device = "desktop" }) {
  const branding = config?.branding || {};
  const hero = branding?.hero || {};
  const theme = config?.theme || {};
  const isMobile = device === "mobile";

  const primary = theme.primary || "#9df03d";
  const onPrimary = theme.onPrimary || "#05070a";

const bgType = hero.backgroundType || hero.bgType || "image";
  const bgColor = hero.bgColor || "#05070a";
  const mediaUrl = hero.mediaUrl || "";
  const overlayColor = hero.overlayColor || "#000000";
  const overlayOpacity = hero.overlayOpacity ?? 0.45;

  const headline = hero.headline || "Reserve your table in seconds";
  const subline = hero.subline || "Instant confirmation · Best seating · No booking fee";

  const hSize = hero.headlineFontSize || (isMobile ? 30 : 56);
  const sSize = hero.sublineFontSize || (isMobile ? 14 : 16);

  const headlineColor = hero.headlineColor || "#ffffff";
  const sublineColor = hero.sublineColor || "rgba(255,255,255,0.85)";

  const heroHeight = isMobile ? 640 : 420;

  const bgLayerStyle = {
    position: "absolute",
    inset: 0,
    zIndex: 0,
    background:
      bgType === "color"
        ? bgColor
        : bgType === "image"
        ? `url(${mediaUrl}) center / cover no-repeat`
        : "transparent"
  };

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    background: overlayColor,
    opacity: overlayOpacity
  };

  const videoBg =
    bgType === "video" && mediaUrl ? (
      <video
        src={mediaUrl}
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0
        }}
      />
    ) : null;

  return (
    <section
      style={{
        position: "relative",
        minHeight: heroHeight,
        overflow: "hidden",
        background: "#000"
      }}
    >
      <div style={bgLayerStyle} />
      {videoBg}
      <div style={overlayStyle} />

      {/* Nav */}
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, zIndex: 10 }}>
        <div style={{ paddingTop: 2 }}>
          <PreviewNav config={config} transparent heroTheme />
        </div>
      </div>

      {/* Hero content */}
      <div
        style={{
          position: "relative",
          zIndex: 5,
          maxWidth: 1240,
          margin: "0 auto",
          padding: isMobile ? "86px 16px 60px" : "120px 48px 70px",
          textAlign: "center"
        }}
      >
        <h1
          style={{
            margin: 0,
            fontWeight: 950,
            letterSpacing: "-0.03em",
            lineHeight: 1.06,
            fontSize: hSize,
            color: headlineColor,
            textShadow: "0 18px 55px rgba(0,0,0,0.55)",
            maxWidth: isMobile ? "100%" : 920,
            marginLeft: "auto",
            marginRight: "auto"
          }}
        >
          {headline}
        </h1>

        <p
          style={{
            marginTop: 14,
            marginBottom: 0,
            fontSize: sSize,
            color: sublineColor,
            lineHeight: 1.6,
            textShadow: "0 12px 30px rgba(0,0,0,0.45)",
            maxWidth: isMobile ? "100%" : 720,
            marginLeft: "auto",
            marginRight: "auto"
          }}
        >
          {subline}
        </p>

        {/* ✅ Booking bar inline — immediately after subtitle */}
        <div
          id="ns-preview-booking"
          style={{
            marginTop: isMobile ? 18 : 26,
            marginLeft: "auto",
            marginRight: "auto",
            width: isMobile ? "100%" : "min(980px, 100%)"
          }}
        >
          <div
            style={{
              borderRadius: isMobile ? 26 : 999,
              padding: isMobile ? 18 : "16px 18px",
              background: "rgba(255,255,255,0.16)",
              border: "1px solid rgba(255,255,255,0.28)",
              backdropFilter: "blur(18px)",
              boxShadow: "0 30px 90px rgba(0,0,0,0.35)"
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1.35fr 1fr 1fr auto",
                gap: 12,
                alignItems: "center"
              }}
            >
              {["Date", "Guests", "Time"].map((label) => (
                <div
                  key={label}
                  style={{
                    padding: "12px 16px",
                    borderRadius: 999,
                    background: "rgba(255,255,255,0.92)",
                    border: "1px solid rgba(0,0,0,0.06)",
                    color: "#0f172a",
                    fontWeight: 850,
                    fontSize: 14,
                    textAlign: "left"
                  }}
                >
                  {label}
                </div>
              ))}

              <button
                type="button"
                style={{
                  padding: "12px 18px",
                  borderRadius: 999,
                  border: 0,
                  fontWeight: 950,
                  fontSize: 14,
                  background: primary,
                  color: onPrimary,
                  cursor: "pointer",
                  boxShadow: "0 18px 40px rgba(0,0,0,0.25)",
                  width: isMobile ? "100%" : "auto"
                }}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
